enum DataSource {
  AnchorageIaaS = 'AnchorageIaaS',
  Arbitrum = 'Arbitrum',
  ArbitrumNova = 'ArbitrumNova',
  Avalanche = 'Avalanche',
  Base = 'Base',
  BinanceSmartChain = 'BinanceSmartChain',
  Bitcoin = 'Bitcoin',
  BitcoinCash = 'BitcoinCash',
  BitcoinIaaS = 'BitcoinIaaS',
  BitGo = 'BitGo',
  Canto = 'Canto',
  Cardano = 'Cardano',
  Circle = 'Circle',
  CoinbaseIaaS = 'CoinbaseIaaS',
  CoinbaseExchangeIaaS = 'CoinbaseExchangeIaaS',
  CoinbasePrimeIaaS = 'CoinbasePrimeIaaS',
  CsvImport = 'CSVImport',
  Dash = 'Dash',
  Dogecoin = 'Dogecoin',
  EthereumIaaS = 'EthereumIaaS',
  Fireblocks = 'Fireblocks',
  Foundry = 'Foundry',
  GeminiIaaS = 'GeminiIaaS',
  Kraken = 'Kraken',
  KuCoin = 'KuCoin',
  Litecoin = 'Litecoin',
  Near = 'Near',
  Optimism = 'Optimism',
  PolygonIaaS = 'PolygonIaaS',
  Proton = 'Proton',
  RippleCustody = 'RippleCustody',
  Rootstock = 'Rootstock',
  Bitfinex = 'Bitfinex',
  SolanaNew = 'SolanaNew',
  SolanaIaaS = 'SolanaIaaS',
  Voltage = 'Voltage',
  Synota = 'Synota',
  Ethereum = 'Ethereum',
  Solana = 'Solana',
  Polygon = 'Polygon',
  Tron = 'Tron',
}

export default DataSource

export function isDataSource(value: string): value is DataSource {
  return Object.values(DataSource).includes(value as DataSource)
}
